<template>
  <!-- FT-217 REQ-09: блок «Ценовые группы» вкладки «Цены». Действия блока —
       пересборка — сохраняются сразу, вне общей панели «Сохранить» вкладки. -->
  <div data-testid="price-groups-block">
    <h3 class="mb-1">
      <v-icon small class="mr-1">mdi-tag-multiple-outline</v-icon>{{ $t("price_groups.title") }}<BetaChip />
    </h3>
    <div class="text-caption text--secondary mb-2">{{ $t("price_groups.hint") }}</div>
    <v-skeleton-loader v-if="loading" type="list-item, list-item" />
    <template v-else>
      <div v-if="!groups.length" class="text-body-2 text--secondary mb-2" data-testid="price-groups-empty">
        {{ $t("price_groups.not_built") }}
      </div>
      <v-simple-table v-else dense class="mb-2" data-testid="price-groups-list">
        <tbody>
          <tr v-for="g in sortedGroups" :key="g.id">
            <td class="px-2">{{ label(g) }}</td>
            <td class="px-2 text-right text-no-wrap">{{ $t("price_groups.cars_in_group", { n: g.cars_count }) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-if="driftedCount > 0" class="text-caption warning--text mb-2" data-testid="price-groups-drifted">
        {{ $t("price_groups.drifted", { n: driftedCount }) }}
      </div>
      <v-btn v-if="isAdminPlus" small outlined color="primary" data-testid="price-groups-rebuild" @click="openPreview">
        <v-icon left small>mdi-refresh</v-icon>{{ groups.length ? $t("price_groups.rebuild") : $t("price_groups.build") }}
      </v-btn>
    </template>

    <v-dialog v-model="dialog" max-width="440">
      <v-card data-testid="price-groups-dialog">
        <v-card-title class="text-h6">{{ $t("price_groups.rebuild_title") }}</v-card-title>
        <v-card-text>
          <v-progress-linear v-if="previewLoading" indeterminate class="my-2" />
          <div v-else-if="preview" data-testid="price-groups-preview">
            {{ $t("price_groups.rebuild_preview", { moved: preview.cars_moved, after: preview.groups_after, before: preview.groups_before }) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="applying" @click="dialog = false">{{ $t("custom.cancel") }}</v-btn>
          <v-btn color="primary" :loading="applying" :disabled="!preview || previewLoading"
            data-testid="price-groups-confirm" @click="apply">
            {{ $t("price_groups.rebuild_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { priceGroupLabel, priceGroupLabelOptions, sortByMinPrice } from "@/utils/priceGroupLabel";
import { fetchPriceGroups, rebuildPriceGroups } from "@/utils/priceGroupsApi";

export default {
  name: "PriceGroupsBlock",
  data() {
    return {
      loading: true,
      unit: null,
      groups: [],
      driftedCount: 0,
      dialog: false,
      preview: null,
      previewLoading: false,
      applying: false,
    };
  },
  computed: {
    sortedGroups() {
      return sortByMinPrice(this.groups);
    },
    labelOptions() {
      return priceGroupLabelOptions(this, this.unit);
    },
  },
  created() {
    this.load();
  },
  methods: {
    label(group) {
      return priceGroupLabel(group, this.labelOptions);
    },
    async load() {
      this.loading = true;
      try {
        const data = await fetchPriceGroups(this);
        this.unit = data.unit || null;
        this.groups = data.groups || [];
        this.driftedCount = data.drifted_count || 0;
      } catch (error) {
        this.setError && this.setError(error, this.$t("price_groups.load_error"));
      } finally {
        this.loading = false;
      }
    },
    // REQ-03: сначала предпросмотр (тот же расчёт без записи) — «сменит группу N,
    // групп станет M», запись — только после подтверждения
    async openPreview() {
      this.dialog = true;
      this.preview = null;
      this.previewLoading = true;
      try {
        this.preview = await rebuildPriceGroups(this, { dryRun: true });
      } catch (error) {
        this.dialog = false;
        this.setError && this.setError(error, this.$t("price_groups.build_error"));
      } finally {
        this.previewLoading = false;
      }
    },
    async apply() {
      if (this.applying) return;
      this.applying = true;
      try {
        await rebuildPriceGroups(this, { dryRun: false });
        this.dialog = false;
        this.$notify && this.$notify(this.$t("price_groups.built"), "", "success");
        await this.load();
      } catch (error) {
        this.setError && this.setError(error, this.$t("price_groups.build_error"));
      } finally {
        this.applying = false;
      }
    },
  },
};
</script>
